import { Component } from '@angular/core';

@Component({
  selector: 'app-parametre-general',
  standalone: true,
  imports: [],
  templateUrl: './parametre-general.component.html',
  styleUrl: './parametre-general.component.scss'
})
export class ParametreGeneralComponent {

}
